<template>
  <div class="user-notification-pagination-container">
    <div>
      <a :class="displayFirstPageButton ? 'pagination-button' : 'pagination-button-disabled'"
              title="First Page"
              :disabled="!this.displayFirstPageButton"
              @click.prevent="showFirstPage">
        <img :src="this.enableFirstPageButtonURL" class="pagination-icon" alt="previous" title="Previous Page">
      </a>
    </div>
    <div>
      <a :class="displayPreviousPageButton ? 'pagination-button' : 'pagination-button-disabled'"
              title="Previous Page"
              :disabled="!this.displayPreviousPageButton"
              @click.prevent="showPreviousPage">
        <img :src="this.enablePreviousPageButtonURL" class="pagination-icon" alt="previous" title="Previous Page">
      </a>
    </div>
    <div style="margin: 5px">
      {{ this.paginationDetails.from }}-{{ this.paginationDetails.to }} out of {{ this.paginationDetails.total }}
    </div>
    <div>
      <a title="Next Page"
              :class="displayNextPageButton ? 'pagination-button' : 'pagination-button-disabled'"
              :disabled="!this.displayNextPageButton"
              @click.prevent="showNextPage">
        <img :src="this.enableNextPageButtonURL" class="pagination-icon" alt="previous" title="Previous Page">
      </a>
    </div>
    <div>
      <a :class="displayLastPageButton ? 'pagination-button' : 'pagination-button-disabled'"
              title="Last Page"
              :disabled="!this.displayLastPageButton"
              @click.prevent="showLastPage">
        <img :src="this.enableLastPageButtonURL" class="pagination-icon" alt="previous" title="Previous Page">
      </a>
    </div>
  </div>
</template>

<script>
import './user-notifications.scss';
import {mapActions, mapGetters, mapState} from "vuex";


export default {
  name: "notification-pagination.vue",
  props: ["flagged"],
  computed: {
    ...mapState('PortalNotificationStore', [
      'loading',
      "paginationDetails",
    ]),
    ...mapGetters('PortalNotificationStore', [
      'requestUrl',
    ]),
    displayPreviousPageButton () {
      return this.paginationDetails.previousPage.url;
    },
    displayNextPageButton () {
      return this.paginationDetails.currentPage.page < this.paginationDetails.lastPage.page;
    },
    displayLastPageButton () {
      return this.paginationDetails.currentPage.page !== this.paginationDetails.lastPage.page;
    },
    displayFirstPageButton () {
      return this.paginationDetails.currentPage.page !== 1;
    },
    enableFirstPageButtonURL () {
      if (this.paginationDetails.currentPage.page !== 1) {
        return `/images/notifications/pagination-begin.svg`;
      }
      return `/images/notifications/pagination-begin-disabled.svg`;
    },
    enableLastPageButtonURL () {
      if(this.paginationDetails.currentPage.page !== this.paginationDetails.lastPage.page){
        return `/images/notifications/pagination-end.svg`
      }
        return `/images/notifications/pagination-end-disabled.svg`
    },
    enablePreviousPageButtonURL () {
      if(this.paginationDetails.previousPage.url){
        return `/images/notifications/pagination-previous.svg`
      }
        return `/images/notifications/pagination-previous-disabled.svg`
    },
    enableNextPageButtonURL () {
      if(this.paginationDetails.currentPage.page < this.paginationDetails.lastPage.page){
        return `/images/notifications/pagination-next.svg`
      }
        return `/images/notifications/pagination-next-disabled.svg`
    },
  },
  methods: {
    ...mapActions('PortalNotificationStore', [
      'fetchNotifications'
    ]),
    showFirstPage () {
      this.fetchNotifications(this.paginationDetails.firstPage.url);
    },
    showPreviousPage () {
      this.fetchNotifications(this.paginationDetails.previousPage.url);
    },
    showNextPage () {
      this.fetchNotifications(this.paginationDetails.nextPage.url);
    },
    showLastPage () {
      this.fetchNotifications(this.paginationDetails.lastPage.url);
    },
  }
};
</script>
